// @flow

import { detectPrimaryLocale } from 'src/helpers/translation-helper';
import { flattenArrayObject } from 'src/helpers';

import type { TranslationState, TranslationAction } from 'stores/flow-type/translation.type';

import {
  GET_LOCALES_REQUEST,
  GET_LOCALES_SUCCESS,
  GET_LOCALES_FAILURE,
  GET_DEFAULT_TRANSLATIONS_BY_LOCALE_REQUEST,
  GET_DEFAULT_TRANSLATIONS_BY_LOCALE_SUCCESS,
  GET_DEFAULT_TRANSLATIONS_BY_LOCALE_FAILURE
} from 'stores/flow-type/translation.type';

const initialState: TranslationState = {
  loading: false,
  loadingLocale: false,
  success: false,
  error: undefined,
  locales: [],
  requestPermissionLocales: false,
  primaryLocale: '',
  total: 0,
  defaultTranslationsByLocale: []
};

const translationReducers = (state: TranslationState = initialState, action: TranslationAction) => {
  switch (action.type) {
    // Get locales
    case GET_LOCALES_REQUEST:
      return { ...state, loadingLocale: true };
    case GET_LOCALES_SUCCESS: {
      const { data } = action.payload;
      let { data: locales = [], total } = data;
      let requestPermissionLocales = false;

      // Temporary fix
      if (locales.length === 0) {
        requestPermissionLocales = true;
        locales = [{ locale: 'en', name: 'English', primary: true, published: true }];
      }

      // Get primary locale
      const primaryLocale = detectPrimaryLocale(locales);

      return {
        ...state,
        loadingLocale: false,
        error: undefined,
        locales,
        requestPermissionLocales,
        primaryLocale,
        total
      };
    }
    case GET_LOCALES_FAILURE:
      return {
        ...state,
        loadingLocale: false,
        success: false,
        error: action.payload
      };

    // Get default translations by locale
    case GET_DEFAULT_TRANSLATIONS_BY_LOCALE_REQUEST:
      return { ...state, loading: true };
    case GET_DEFAULT_TRANSLATIONS_BY_LOCALE_SUCCESS: {
      const { data: response } = action.payload;

      // Flatten data
      const defaultTranslationsByLocale = flattenArrayObject(response.data);

      return {
        ...state,
        loading: false,
        error: undefined,
        defaultTranslationsByLocale
      };
    }
    case GET_DEFAULT_TRANSLATIONS_BY_LOCALE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default translationReducers;
